import axios from 'axios'
import {
  Message
} from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    if (token) {
      console.log('请求头中的token:', token)
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 修改判断条件，使用 code === 200
    if (res.code !== 200) {
      Message({
        message: res.msg || '错误', // 使用接口返回的 msg 字段
        type: 'error',
        duration: 3000
      })
      return Promise.reject(new Error(res.msg || '错误'))
    } else {
      return res // 直接返回响应数据
    }
  },
  error => {
    console.log('err' + error)
    Message({
      message: error.message,
      type: 'error',
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export default service